import { ApplicationModes } from '../constants/application-modes';

import { areLLMPoweredFeaturesEnabled } from './entitlement-checks';

/**
 * Determines if the Leap query should be fetched based on the application mode and feature flags.
 */
export const isLeapQueryEnabled: (
	appMode: ApplicationModes,
	isAdminHubAIEnabled: boolean,
	isRovoLLMEnabled: boolean,
) => boolean = (
	appMode: ApplicationModes,
	isAdminHubAIEnabled: boolean,
	isRovoLLMEnabled: boolean,
): boolean =>
	appMode === ApplicationModes.Rovo &&
	areLLMPoweredFeaturesEnabled(appMode, isAdminHubAIEnabled, isRovoLLMEnabled);
